import {
  type ChatComponents,
  type ChatEntry,
  type KeyOfChatComponentType,
} from './typings';

/**
 * Returns parsed entries from chatComponentType:
 * - nonNullEntries: all entries where the value is not null
 * - activeEntries: subset where isActive is true
 */
export const getChatEntries = (
  chatComponents: ChatComponents,
): { nonNullEntries: ChatEntry[]; activeEntries: ChatEntry[] } => {
  const nonNullEntries = Object.entries(chatComponents).filter(
    (entry): entry is ChatEntry => entry[1] !== null,
  );
  const activeEntries = nonNullEntries.filter(([, value]) => value.isActive);
  return { nonNullEntries, activeEntries };
};

/**
 * Returns the key of the entry with the highest createdAt from a given list.
 * Returns null if the list is empty.
 */
export const getHighestCreatedAtKey = (
  entries: ChatEntry[],
): KeyOfChatComponentType | null => {
  if (entries.length === 0) return null;
  return entries.reduce((prev, curr) =>
    curr[1].lastUpdated > prev[1].lastUpdated ? curr : prev,
  )[0];
};
